import React from 'react';
import { Parallax, ParallaxLayer } from '@react-spring/parallax';

const Challenge = () => {
    return (
        <div>
            <h2>The Challenge</h2>
            <Parallax pages={3}>
                <ParallaxLayer offset={0} speed={0.5} style={{ backgroundImage: 'url(path/to/image-1.jpg)', backgroundSize: 'cover' }}>
                    <h2>An Overwhelming Amount of Data</h2>
                    <p>Explain more about the first topic here...</p>
                </ParallaxLayer>

                <ParallaxLayer offset={1} speed={0.5} style={{ backgroundImage: 'url(path/to/image-2.jpg)', backgroundSize: 'cover' }}>
                    <h2>A Profusion of Forms</h2>
                    <p>Explain more about the second topic here...</p>
                </ParallaxLayer>

                <ParallaxLayer offset={2} speed={0.5} style={{ backgroundImage: 'url(path/to/image-3.jpg)', backgroundSize: 'cover' }}>
                    <h2>Questions without Answers</h2>
                    <p>Explain more about the third topic here...</p>
                </ParallaxLayer>
            </Parallax>
        </div>
    );
}

export default Challenge;
